"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    SCHOOL: 'school',
    UNIVERSITY: 'university',
};
//# sourceMappingURL=educationTypes.js.map